import { combineReducers } from 'redux'

import { ui, UiState } from './ui-reducer'
import { user, UserState } from './user-reducer'
import { account, AccountState } from './account-reducer'
import { oauth, OauthState } from './oauth-reducer'
import { onboarding, OnboardingState } from './onboarding-reducer'
import { login, LoginState } from './login-reducer'
import { metrics, MetricsState } from './metrics-reducer'
import { explain, ExplainState } from './explain-reducer'
import { audit, AuditState } from './audit-reducer'
import { anomalies, AnomaliesState } from './anomalies-reducer'
import { anomaly, AnomalyState } from './anomaly-reducer'
import { site, SiteState } from './site-reducer'
import { support, SupportState } from './support-reducer'
import { register, RegisterState } from './register-reducer'
import { calendar, CalendarState } from './calendar-reducer'
import { campaignCodes, CampaignCodesState } from './campaign-codes-reducer'
import { causes, CauseState } from './causes-reducer'
import { dimensions, DimensionsState } from './dimensions-reducer'
import { reports, ReportState } from './reports-reducer'
import { graphql, GraphQLState } from './graphql-reducer'

const reducers = combineReducers({
  ui,
  user,
  account,
  oauth,
  onboarding,
  login,
  anomalies,
  anomaly,
  audit,
  site,
  support,
  register,
  calendar,
  explain,
  metrics,
  campaignCodes,
  causes,
  dimensions,
  reports,
  graphql,
})

const rootReducer = (
  state:
    | {
        ui: UiState
        user: UserState
        account: AccountState
        oauth: OauthState
        onboarding: OnboardingState
        login: LoginState
        metrics: MetricsState
        explain: ExplainState
        audit: AuditState
        anomalies: AnomaliesState
        anomaly: AnomalyState
        site: SiteState
        support: SupportState
        register: RegisterState
        calendar: CalendarState
        campaignCodes: CampaignCodesState
        causes: CauseState
        dimensions: DimensionsState
        reports: ReportState
        graphql: GraphQLState
      }
    | undefined,
  action: ReduxAction,
): any => {
  let localState = state
  if (action.type === 'LOGOUT') {
    localState = undefined
  }

  return reducers(localState, action)
}

export default rootReducer
